import { Client } from "@/shared/services/client"
import { SalesStatus } from "@/shared/models/sales-status"
import Crud from "./crud"

const client = new Client()

export class SalesStatusService extends Crud<SalesStatus> {
    constructor() {
        super("crm/sales-statuses")
    }

    getCachedSalesStatuses(): Promise<{ data: SalesStatus[] }> {
        return client.get(`${this.endpoint}`)
    }
}
